import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./otherAppsLikeThis.html";
import { WireStore } from '@oneappexchange/lwc-wired';
import { FeatureFlags } from '~/modules/feature_flags';
import { WireI18n } from '~/modules/stores/i18nStore';
import { OtherAppsLikeThisStatus, otherAppsLikeThisStore } from '~/modules/stores/otherAppsLikeThisStore';
class OtherAppsLikeThis extends LightningElement {
  constructor(...args) {
    super(...args);
    this.
    // @ts-expect-error * Automated Type Error Fix
    i18n = null;
    this.
    // @ts-expect-error * Automated Type Error Fix
    otherAppsLikeThisState = null;
  }
  get otherAppsLikeThisExists() {
    return FeatureFlags.FF_OTHER_APPS_LIKE_THIS && this.otherAppsLikeThisState.searchResults?.listings?.length >= 1 && this.otherAppsLikeThisState.loadingStatus !== OtherAppsLikeThisStatus.ERROR;
  }
  get props() {
    return {
      title: this.i18n.heading.otherAppsLikeThis,
      variant: 'stack',
      format: 'listing',
      type: 'recommended'
    };
  }
  get otherAppsListings() {
    return this.otherAppsLikeThisState.searchResults?.listings || [];
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(OtherAppsLikeThis, {
  wire: {
    i18n: {
      adapter: WireI18n,
      config: function ($cmp) {
        return {};
      }
    },
    otherAppsLikeThisState: {
      adapter: WireStore,
      dynamic: [],
      config: function ($cmp) {
        return {
          store: otherAppsLikeThisStore
        };
      }
    }
  }
});
const __lwc_component_class_internal = _registerComponent(OtherAppsLikeThis, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;